import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const CustomSearchField = ({ searchQuery, setSearchQuery, ...props }) => {
  
  return (
    <TextField
      variant="outlined"
      placeholder="Search..."
      value={searchQuery}
      fullWidth
      onChange={(e) => setSearchQuery(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        sx: {
          height: "40px", // Adjust height as needed
          "& .MuiOutlinedInput-input": {
            padding: "8px", // Adjust padding as needed
            fontFamily: "Urbane-Light",
            fontSize: "13px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "grey", // Optional: change the border color
          },
        },
      }}
      sx={{
        borderRadius: "50px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "50px",
          paddingRight: "0",
          height: "35px",
          fontFamily: "Urbane-Light",
          fontWeight: 500,
        },
        "& .MuiOutlinedInput-input": {
          padding: "10px 12px",
          fontSize: "13px",
        },
      }}
      {...props}
    />
  );
};

export default CustomSearchField;
